var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.43 101.86",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mug_svg__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:18px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mug_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mug_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "mug_svg__cls-1",
    d: "M122.24 11.38H37.73a4.19 4.19 0 01-4.18-4.19A4.19 4.19 0 0137.73 3h84.51a4.19 4.19 0 014.19 4.19 4.19 4.19 0 01-4.19 4.19zM37.67 74.83L19 56.92c-6.7-6.7-9.71-15.91-3-22.61 6.26-6.26 15-5.72 21.69-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mug_svg__cls-1",
    d: "M122.3 11.38v80.5a7 7 0 01-7 7H44.65a7 7 0 01-7-7v-80.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mug_svg__cls-1",
    d: "M37.67 24.15a22.86 22.86 0 00-28 35.73l28 28"
  })))));
}

var MemoSvgMug = /*#__PURE__*/React.memo(SvgMug);
export default MemoSvgMug;